import React, { useState } from 'react';
import {
  MDBContainer,
  MDBCol,
  MDBRow,
//   MDBBtn,
//   MDBIcon,
  MDBInput,
//   MDBCheckbox
} from 'mdb-react-ui-kit';
import login from '../../css/login.module.css'; // Optional if you use custom styles
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { loginUser } from '../shared/ApiEndpoint';
import axiosInstance from '../../utils/axiosInstance';

function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [userCredential,setUserCredential]=useState({
    email:'',
    password:'',
  })

  const handleLogin = async() => {
   try {
     const res = await axiosInstance.post(loginUser, {...userCredential}, {withCredentials: true});
    if(res.status===200){
      const {access_token,user}=res.data;
      localStorage.setItem("jwtToken", access_token);
      localStorage.setItem("userId", user.id);
      localStorage.setItem("userName", user.name);
      localStorage.setItem("email",user.email)
      localStorage.setItem("first_name",user.first_name);
      localStorage.setItem("last_name",user.last_name);
      localStorage.setItem("profile_image",user.profile_image)
      localStorage.setItem("role",user.role)
      window.location.href="/";
    }
   } catch (error) {
     console.error("Login failed:", error);
   }
  }
  const handleOnchange=(e)=>{
    const {name,value}=e.target;
    setUserCredential({...userCredential,[name]:value})
  }

  return (
    <MDBContainer fluid className="p-3 my-5">
      <MDBRow className="align-items-center">

        {/*  Image Column - responsive */}
        <MDBCol md="6" className="mb-4 mb-md-0 text-center">
          <img
            src="/assets/images/loginimage.svg"
            className={`img-fluid ${login.loginImage}`}
            alt="Login"
          />
        </MDBCol>

        {/*  Form Column */}
        <MDBCol md="6" className="px-5">
            <label htmlFor="emailInput">Email address</label>
          <MDBInput
            wrapperClass="mb-4"
            // label="Email address"
            id="emailInput"
            type="email"
            name='email'
            size="lg"
            onChange={handleOnchange}
          />
           <div className="mb-4 position-relative">
      <label htmlFor="passwordInput" className="form-label">Password</label>

      <MDBInput
        id="passwordInput"
        type={showPassword ? 'text' : 'password'}
        size="lg"
        name='password'
        onChange={handleOnchange}
        className="pe-5" // Add padding-right to prevent text overlap
      />

      <span
        onClick={() => setShowPassword(prev => !prev)}
        style={{
          position: 'absolute',
          top: '65%',
          right: '20px',
          transform: 'translateY(-50%)',
          cursor: 'pointer',
          zIndex: '2',
          fontSize: '1.4rem',
        }}
      >
        {showPassword ? <FaEyeSlash /> : <FaEye />}
      </span>
    </div>

          <div className="d-flex justify-content-end mb-4">
            {/* <MDBCheckbox
              name="rememberMe"
              id="rememberMe"
              label="Remember me"
            /> */}
            <a href="#!" className="text-decoration-none">Forgot password?</a>
          </div>

         <button onClick={handleLogin} className="btn btn-primary mb-4 w-100">Sign in</button>

          {/*  Divider Line */}
          <div className={`d-flex align-items-center my-4 ${login?.divider}`}>
            <div className="border-top w-100"></div>
            <p className="text-center fw-bold mx-3 mb-0">OR</p>
            <div className="border-top w-100"></div>
          </div>

          {/*  Social Buttons */}
          {/* <MDBBtn className="mb-3 w-100" size="lg" style={{ backgroundColor: '#3b5998' }}>
            <MDBIcon fab icon="facebook-f" className="me-2" />
            Continue with Facebook
          </MDBBtn>

          <MDBBtn className="mb-4 w-100" size="lg" style={{ backgroundColor: '#55acee' }}>
            <MDBIcon fab icon="twitter" className="me-2" />
            Continue with Twitter
          </MDBBtn> */}

          <p className="text-center mt-3">
            Don’t have an account? <a href="#!" className="text-primary">Sign up</a>
          </p>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
}

export default Login;
